import { rServices } from '@/plugins/api';
import { getDownloadLinkByType } from '@/helpers/files';

import BaseModel from '@/models/list/base';

export default class EventCertificate extends BaseModel {
  constructor(eventCertificate) {
    super(eventCertificate);

    this.id = eventCertificate.id;
    this.user_id = eventCertificate.user_id;
    this.event_id = eventCertificate.event_id;
    this.nomination_id = eventCertificate.nomination_id;
    this.awards = eventCertificate.awards || null;
  }

  async getFile(eventName) {
    const params = {
      expand: 'file',
    };
    const args = [this.id];

    const { response, error } = await rServices.events.getCertificateFile({ args, params });
    if (error) {
      return { error };
    }

    const fileRawData = response.data.data.file;
    const fileName = `Сертификат ${eventName}`;
    const url = getDownloadLinkByType(fileRawData, fileName);

    response.data.data = {
      url,
      fileName,
    };

    return { response };
  }
}
